import { useState } from 'react';

import { useFormik } from 'formik';
import * as yup from 'yup';
import {
  Button,
  TextField,
  Grid,
  Typography,
  FormControl,
  CircularProgress,
} from '@mui/material';
import { useForgotPasswordMutation } from '../../../../graphql/generated/graphql';

import { EmailForm } from '../../../config/interfaces';
import MsgForget from '../../components/onbording/msg-forget';
import OnBoardingLayout from '../../../theme/templates/on-boarding';

const ForgetPage = () => {
  const [forgot] = useForgotPasswordMutation();
  const [recover, setRecover] = useState(false);
  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState('');

  const initialValues: EmailForm = {
    email: '',
  };
  const RecoverSchema = yup.object().shape({
    email: yup.string().email('Invalid email').required('Required'),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: RecoverSchema,
    onSubmit: async (variables) => {
      setLoader(true);
      setEmail(variables.email);
      try {
        await forgot({
          variables,
        });
        setRecover(true);
      } catch (e) {
        setRecover(false);
      }
      setLoader(false);
    },
  });

  return (
    <OnBoardingLayout>
      <Grid
        sx={{
          maxWidth: '90%',
          width: '500px',
          mb: 2,
          mx: 4,
          py: 2,
          px: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        item
      >
        <Typography
          component="h1"
          variant="h3"
          sx={{
            textAlign: 'center',
            mb: 5,
          }}
        >
          Forgot  your password? Not a problem!.
        </Typography>
        {recover ? (
          <MsgForget email={email} />
        ) : (
          <>
            <Typography
              component="p"
              variant="body1"
              sx={{
                mb: 2,
              }}
            >
              Enter your email below for a quick reset link.
            </Typography>
            <FormControl
              fullWidth
              component="form"
              onSubmit={formik.handleSubmit}
            >
              <TextField
                autoFocus
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                {loader ? (
                  <CircularProgress color="primary" />
                ) : (
                  'Restore password'
                )}
              </Button>
            </FormControl>
            <Typography
              component="p"
              variant="body1"
              sx={{
                mt: 2,
                textAlign: 'center'
              }}
            >
              if you need further assistance, feel free to contact us at hello@cinemahive.com
            </Typography>
          </>
        )}
      </Grid>
    </OnBoardingLayout>
  );
};

export default ForgetPage;
